import { AddOns } from "@nova/constants"
import { initializeCenterModalForComponentAction } from "features/content-overlay/slice"
import { ModalNames } from "features/modals/types"
import { useAppDispatch } from "integrations/redux/hooks"
import { setActiveSidePanelModal } from "panels/content/side-panel/slice"
import { useCallback } from "react"
import { setLicensePaywallType, setAddOnPaywallType } from "./actions"
import { LicensePaywallType } from "./types"
import { showGlobalModal } from "runlevel/actions"

export const usePaywalls = () => {
    const dispatch = useAppDispatch()

    const showLicensePaywallModal = useCallback(
        (paywallType: LicensePaywallType) => {
            dispatch(setActiveSidePanelModal(undefined))
            setTimeout(() => {
                dispatch(initializeCenterModalForComponentAction(ModalNames.LicensePaywallModal))
                dispatch(setLicensePaywallType(paywallType))
                dispatch(showGlobalModal())
            }, 0)
        },
        [dispatch]
    )

    const showAddOnPaywallModal = useCallback(
        (type: AddOns) => {
            dispatch(setActiveSidePanelModal(undefined))
            setTimeout(() => {
                dispatch(initializeCenterModalForComponentAction(ModalNames.AddOnPaywallModal))
                dispatch(setAddOnPaywallType(type))
                dispatch(showGlobalModal())
            }, 0)
        },
        [dispatch]
    )

    return { showLicensePaywallModal, showAddOnPaywallModal }
}
